import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {IconButton, Typography, useTheme} from '@mui/material';
import Box from '@mui/material/Box';
import {grey} from '@mui/material/colors';
import Grid from '@mui/material/Grid';
import {bool, shape} from 'prop-types';
import {useNavigate} from 'react-router-dom';

import useProfile from '../../../../../hooks/providers/useProfile';
import {ressourceShape} from '../../../../../proptypes-shapes';
import {makeHumanFriendlyUrl} from '../../../../../utils';

// eslint-disable-next-line react/prop-types
const HeaderSingleHelpRessource = ({ressource, hasExpandButton = false, onCategoryClick = null}) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const {setOnboardingHelpRessourceModalIFrameSrc, setIsOnboardingHelpRessourceModalOpen, setIsOnboardingPopperOpen, expandedOnboardingMenuItem, setExpandedOnboardingMenuItem} = useProfile();

  const isExpanded = expandedOnboardingMenuItem === ressource.id;

  const toggleExpanded = () => {
    if (!hasExpandButton) {
      onCategoryClick();
      setIsOnboardingPopperOpen(false);
      return;
    }
    setExpandedOnboardingMenuItem(currentExpandedOnboardingMenuItem => (currentExpandedOnboardingMenuItem === ressource.id ? null : ressource.id));
  };

  const handleCanvaButtonClick = (documentGroup, document) => {
    const formattedGroupName = makeHumanFriendlyUrl(documentGroup);
    const formattedDocumentName = makeHumanFriendlyUrl(document);
    navigate(`/${formattedGroupName}/${formattedDocumentName}`);
  };

  const handleHubspotButtonClick = link => {
    setOnboardingHelpRessourceModalIFrameSrc(link);
    setIsOnboardingHelpRessourceModalOpen(true);
  };

  const handleMenuItemClick = item => {
    if (item.src_iframe === 'canva') {
      const subtitleUrl = makeHumanFriendlyUrl(item.subtitle);
      handleCanvaButtonClick(ressource.id, subtitleUrl);
    } else if (item.src_iframe === 'hubspot' || item.src_iframe === 'forms') {
      handleHubspotButtonClick(item.link);
    }
    setExpandedOnboardingMenuItem(null);
    setIsOnboardingPopperOpen(false);
  };

  return (
    <Box
      sx={{
        cursor: 'pointer',
        borderBottom: `1px solid ${grey[300]}`
      }}
      py={1}
      pl={2}
      pr={1}
    >
      <Grid onClick={toggleExpanded} container alignItems="center" justifyContent="space-between" flexWrap="nowrap" py={0.2}>
        <Grid item xs={10}>
          <Grid container flexWrap="nowrap">
            {ressource.icon}
            <Typography color="text.secondary" fontSize={16}>
              {ressource.title}
            </Typography>
          </Grid>
        </Grid>

        {hasExpandButton ? (
          <Grid item>
            <IconButton aria-label="close" color="inherit" size="small" sx={{p: 0, mr: 0.7}}>
              {isExpanded ? <ExpandMoreIcon /> : <ExpandLessIcon />}
            </IconButton>
          </Grid>
        ) : null}
      </Grid>
      {isExpanded ? (
        <Box px={1.5}>
          {ressource.links.map(l => {
            return (
              <Typography
                onClick={() => handleMenuItemClick(l)}
                my={1.5}
                color="text.secondary"
                fontSize={14}
                key={l.subtitle}
                sx={{
                  '&:hover': {
                    color: theme.palette.secondary.main
                  }
                }}
              >
                {l.subtitle}
              </Typography>
            );
          })}
        </Box>
      ) : null}
    </Box>
  );
};

HeaderSingleHelpRessource.propTypes = {
  ressource: ressourceShape.isRequired,
  hasExpandButton: bool.isRequired
};

export default HeaderSingleHelpRessource;
